module.exports = __webpack_public_path__ + "img/aiBg.d36fb048.png";